module.exports = __webpack_public_path__ + "img/course_0012.e0c43b5.png";